import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/brand/Logo";
import { SOLUTIONS, PLATFORMS, CONTACT } from "@/data/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-white">
      <div className="container-cb py-14">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 lg:col-span-1">
            <Logo size={36} />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-cbslate">
              One partner. Every cloud. No guesswork. Multi-cloud transformation, engineering and managed services for measurable outcomes.
            </p>
            <p className="mt-4 text-sm text-cbslate">{CONTACT.phone}</p>
            <a href={`mailto:${CONTACT.email}`} className="text-sm font-medium text-primary">{CONTACT.email}</a>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-cbink">Solutions</h4>
            <ul className="mt-4 space-y-2.5">
              {SOLUTIONS.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link to={`/solutions/${s.slug}`} className="text-sm text-cbslate hover:text-primary">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-cbink">Platforms</h4>
            <ul className="mt-4 space-y-2.5">
              {PLATFORMS.map((p) => (
                <li key={p.slug}>
                  <Link to={`/platforms/${p.slug}`} className="text-sm text-cbslate hover:text-primary">{p.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-cbink">Company</h4>
            <ul className="mt-4 space-y-2.5">
              {[["About", "/about"], ["Leadership", "/why#leadership"], ["Partners", "/partners"], ["Careers", "/careers"], ["Contact", "/contact"]].map(([l, t]) => (
                <li key={t}><Link to={t} className="text-sm text-cbslate hover:text-primary">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-cbink">Resources</h4>
            <ul className="mt-4 space-y-2.5">
              {[["Insights", "/resources/insights"], ["Case Studies", "/resources/case-studies"], ["Whitepapers", "/resources/whitepapers"], ["Cloud Guides", "/resources/cloud-guides"], ["Client Portal", "/portal"]].map(([l, t]) => (
                <li key={t}><Link to={t} className="text-sm text-cbslate hover:text-primary">{l}</Link></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-border pt-6 md:flex-row md:items-center">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-cbslate">
            Build <span className="text-primary">&middot;</span> Modernize <span className="text-primary">&middot;</span> Operate <span className="text-primary">&middot;</span> Together
          </p>
          <nav aria-label="Legal" className="flex flex-wrap items-center gap-x-5 gap-y-2">
            {[["Privacy Policy", "/privacy-policy"], ["Terms of Use", "/terms-of-use"], ["Cookie Policy", "/cookie-policy"]].map(([l, t]) => (
              <Link key={t} to={t} className="text-xs font-medium text-cbslate hover:text-primary" data-testid={`footer-legal-${t.replace(/\//g, "")}`}>{l}</Link>
            ))}
          </nav>
          <p className="text-xs text-cbslate">&copy; {year} Cloud Beaker Corporation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
